import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  Heart, GraduationCap, Home, HardHat, Monitor, Users, Scissors, HandHeart,
  type LucideIcon,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  Heart, GraduationCap, Home, HardHat, Monitor, Users, Scissors, HandHeart,
};

export interface ServiceAreaDB {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  icon: LucideIcon;
  color: string;
  bgColor: string;
  isActive: boolean;
  comingSoon: boolean;
  displayOrder: number;
}

async function fetchAreas(onlyActive: boolean): Promise<ServiceAreaDB[]> {
  let query = supabase
    .from('service_areas')
    .select('*')
    .order('display_order');

  if (onlyActive) {
    query = query.eq('is_active', true);
  }

  const { data, error } = await query;
  if (error) {
    console.error('Error fetching service areas:', error);
    return [];
  }

  return (data || []).map((row) => ({
    id: row.slug,
    slug: row.slug,
    name: row.name,
    description: row.description,
    icon: ICON_MAP[row.icon] || Heart,
    color: row.color,
    bgColor: row.bg_color,
    isActive: row.is_active,
    comingSoon: row.coming_soon,
    displayOrder: row.display_order,
  }));
}

export function useServiceAreas(onlyActive = false) {
  const { data: areas = [], isLoading: loading } = useQuery({
    queryKey: ['service-areas', onlyActive],
    queryFn: () => fetchAreas(onlyActive),
    staleTime: 5 * 60 * 1000, // 5 min cache
  });

  return { areas, loading };
}
